import { atom } from "jotai";
import { Form } from "../types/IForm";
const intialFormConfig : Form = {
    sections: [{task_data:[],stepNbr: 0, sectionName: 'Section 1'}],
    name: "",
    description: ""
}

export const formAtom = atom<Form>(intialFormConfig);
